import { TemplatePage } from './types';

const presentationPage: TemplatePage = {
  header: {
    color: '#F2F1EF',
    icon: 'images/video-templates/presentation.jpg',
    title: 'Presentation Video Templates',
    title_meta: 'Free Presentation Video Templates',
    description_meta:
      'Jumpstart video creation with free presentation video templates. Try now!',
    description:
      'Present your business in a unique and memorable way. Make these professionally designed videos your own by ' +
      'changing the message and adding your logo. Upload your own media files or browse our integrated stock library to ' +
      'find the perfect footage for your video presentation.'
  },
  footer: {
    category: 'Presentation',
    description:
      'Ready-made video templates are the easiest way to create stunning marketing videos. Wow your audience and catch ' +
      'their attention with these customizable videos for any use case.'
  },
  content: [
    {
      type: 'templates',
      title: 'presentation video',
      search: { name: 'presentation video' }
    },
    {
      type: 'stocks',
      title: 'presentation video',
      search: { name: 'presentation video' }
    },
    { type: 'calendar' }
  ]
};

export default presentationPage;
